/**
 * @constructor
 * @mixes Person
 *
 * NOTE: REPRESENTS COMPANY & PERSON DATA!
 * For compatibility with platform, maintainability and upgradability reasons the constructor is left 'Person'
 *
 */
define([
    'origEdge/quoteandbind/common/models/Person',
], (OOTBPerson) => {

    Person.prototype = Object.create(OOTBPerson.prototype);
    Person.prototype.constructor = Person;
    function Person(data) {
        // call super constructor
        OOTBPerson.call(this, data);

        // since getDisplayName is defined in the OOTB Persons constructor, we need to override it here
        const ootbGetDisplayName = this.getDisplayName;
        this.getDisplayName = function (defaultName, $filter) {
            if (this.isCompany === true || this.isCompany === 'true') {
                return this.companyName || '';
            } 
                return ootbGetDisplayName.apply(this, defaultName, $filter);
            
        };
    }

    return Person;
});



// WEBPACK FOOTER //
// ./app/customer/js/src/edge/quoteandbind/common/models/Person.js